import { createFileRoute } from "@tanstack/react-router";
import { OrderScreen, type OrderSearch } from "../features/order/order-screen";

export const Route = createFileRoute("/orders/$orderId")({
	/** `add`: the item picker is open. `from`: where Back goes. */
	validateSearch: (search: Record<string, unknown>): OrderSearch => ({
		...(search.add === true || search.add === "true" ? { add: true } : {}),
		...(search.from === "tables" ? { from: "tables" as const } : {}),
	}),
	component: Page,
});

function Page() {
	const { orderId } = Route.useParams();
	const search = Route.useSearch();
	return <OrderScreen key={orderId} orderId={orderId} search={search} />;
}
